// https://developers.google.com/maps/documentation/javascript/examples/geocoding-reverse
export const geocode = (location) => new Promise((resolve, reject) => {
  let retryTimes = 0
  const maxRetryTimes = 9

  const interval = setInterval(() => {
    if (retryTimes === maxRetryTimes) {
      clearInterval(interval)
    }
    retryTimes += 1
    if (window.google) {
      clearInterval(interval)
      const geocoder = new window.google.maps.Geocoder()
      geocoder.geocode({ location }, (results, status) => {
        if (status === 'OK') {
          if (results[0]) {
            resolve(results[0].formatted_address)
          } else {
            reject(new Error('No results found'))
          }
        } else {
          reject(new Error(status))
        }
      })
    }
  }, 300)
})
